import Helper from '@ember/component/helper';
import { type Registry as Services, service } from '@ember/service';

// The AI tab links to a route gated by the `ai_drafts.create` permission, which
// owners/restricted teammates cannot be granted. Showing the tab to them surfaces
// a link that redirects them off the page when clicked, so its visibility must
// mirror both the feature flag and that permission.
export default class CanSeeAiTabHelper extends Helper {
  @service session!: Services['session'];
  @service featureFlags!: Services['feature-flags'];

  compute(): boolean {
    return (
      this.featureFlags.gate.enabled('ai_inbox_tab') &&
      (this.session.currentUser?.hasAccessTo('ai_drafts.create') ?? false)
    );
  }
}
